<template>
  <div>
    <!-- <ul class="flexList"> -->
    Andons stoppés ce jour / moyenne quotidienne<br/>
    <p class="andoncount">
    <span :class='[serieAndons[0].data[4] - serieAndons[1].data[4] >= 0 ? "good": "bad"]'>{{ serieAndons[0].data[4] }}</span> / <span>{{ serieAndons[1].data[4] }}</span>
    </p>
    <!-- <li>
      <apexchart class="chartDisplay" type="line" :options="optionScans" :series="serieScans"></apexchart>
    </li> -->
    <!-- <li>
      <apexchart class="chartDisplay" type="line" :options="optionAndons" :series="serieAndons"></apexchart>
    </li> -->
    <!-- <li>
      <apexchart class="chartDisplay" type="bar" :options="optionDelay" :series="serieDelay"></apexchart>
    </li> -->
    <!-- </ul> -->
  </div>
</template>

<script>

export default {
  props: ['stats', 'averageTimeAndon15Days', 'averageTimeAndon30Days'],
  data: function() {
    return {
      optionScans: {
        legend: {
          show: true,
          showForSingleSeries: true
        },
        chart: {
          id: 'Scans',
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: this.stats.daily
            .map(el => el.today.substring(5, 10))
            .reverse()
        },
        colors: ['#60C2F6', '#5FAE58']
      },
      serieScans: [
        {
          name: 'Moyenne mensuelle de carte scannées',
          data: this.stats.average
            .map(averageItem => averageItem.nbr_scanned)
            .reverse()
        },
        {
          name: 'Cartes scannées ce jour',
          data: this.stats.daily
            .map(dailyItem => dailyItem.nbr_scanned)
            .reverse()
        }
      ],
      optionAndons: {
        stroke: {
          width: [4, 4, 2, 2],
          curve: 'straight',
          dashArray: [0, 0, 5, 5]
        },
        chart: {
          id: 'Andons',
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: this.stats.daily
            .map(el => el.today.substring(5, 10))
            .reverse()
        },
        // colors: ['#F66079', '#5FAE58', '#71023A', '#026C41']
      },

      serieAndons: [
        // {
        //   name: 'Andons créés ce jour',
        //   type: 'area',
        //   data: this.stats.daily
        //     .map(dailyItem => dailyItem.andon_created)
        //     .reverse()
        // },
        {
          name: 'Andons stoppés ce jour',
          type: 'area',
          data: this.stats.daily
            .map(dailyItem => dailyItem.andon_stopped)
            .reverse()
        },
        // {
        //   name: "Moyenne mensuelle d'andons créés",
        //   type: 'line',
        //   data: this.stats.average
        //     .map(avgItem => avgItem.andon_created)
        //     .reverse()
        // },
        {
          name: "Moyenne mensuelle d'andons stoppés",
          type: 'line',
          data: this.stats.average
            .map(avgItem => avgItem.andon_stopped)
            .reverse()
        }
      ],
      optionDelay: {
        legend: {
          show: true,
          showForSingleSeries: true
        },
        chart: {
          id: 'Delay',
          toolbar: {
            show: false
          }
        },

        yaxis: {
          opposite: false,
          reversed: true,
          labels: {
            show: false
          }
        },
        colors:
          this.averageTimeAndon30Days >= this.averageTimeAndon15Days
            ? ['#5FAE58']
            : ['#F66079'],
        xaxis: {
          categories: ['dernier mois', '2 dernières semaines'],
          position: 'top'
        }
      },
      serieDelay: [
        {
          name: "Temps moyen  d'arrêt d'un andon en heures",
          data: [this.averageTimeAndon30Days, this.averageTimeAndon15Days]
        }
      ]
    }
  }
}
</script>

<style scoped>
.chartDisplay {
  width: 28vw;
  min-width: 400px;

  margin: 0;
  padding: 0;
}

.good {
  color: green;
}

.bad {
  color:red;
}
.andoncount {
  font-size: 1.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/andon/stats.vue